module.exports = __webpack_public_path__ + "static/media/intro-photowall-10.3ff95e70.jpg";